var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { observer } from 'mobx-react';

import ReactTable from 'react-table';
import 'react-table/react-table.css';

import './DataTable.scss';

var DataTable = observer(function (props) {
  var store = props.store,
      style = props.style,
      scale = props.scale,
      listName = props.listName,
      _props$idField = props.idField,
      idField = _props$idField === undefined ? 'id' : _props$idField,
      otherProps = _objectWithoutProperties(props, ['store', 'style', 'scale', 'listName', 'idField']);

  var list = listName || 'dataList';
  var data = store[list].toJS();
  var filtered = props.filter ? data.filter(props.filter) : data;
  var toDisplay = props.onlyActive ? filtered.filter(function (e) {
    return !(e.locked || false);
  }) : filtered;
  var selectedID = store.selected[idField];
  var scaledFontSize = 100 * (scale || 1.0) + '%';
  return React.createElement(ReactTable, _extends({ data: toDisplay,
    className: '-highlight selectable',
    style: _extends({ minHeight: '70px', maxHeight: '400px', marginBottom: '12px', fontSize: scaledFontSize, lineHeight: '1em' }, style),
    pageSize: toDisplay.length,
    showPagination: false,
    defaultSorted: props.sorting || [{
      id: 'name'
    }],
    getTrProps: function getTrProps(state, rowInfo) {
      var locked = rowInfo && rowInfo.original && rowInfo.original.locked ? 'locked ' : '';
      var selectedCls = rowInfo && rowInfo.original && rowInfo.original[idField] === selectedID ? 'selected' : '';
      return {
        className: locked + selectedCls,
        onClick: store.select(rowInfo.original)
      };
    }
  }, otherProps));
});
export { DataTable };